// import { configureStore } from '@reduxjs/toolkit';
// import authReducer from '../slices/authSlice';

// const store = configureStore({
//   reducer: {
//     auth: authReducer,
//   },
// });

// export default store;

import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "../slices/authSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { thunk } from "redux-thunk"; // Use default import for thunk

const rootPersistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // Correctly configured whitelist
};

const rootReducer = combineReducers({
  auth: authReducer,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(thunk),
});

export const persistor = persistStore(store);

export default store;

// Log the state after rehydration
persistor.subscribe(() => {
  const state = store.getState();
  // //console.log("Rehydrated state:", state);
});
